module.exports = __webpack_public_path__ + "img/paletIcon.4947693e.png";